import { render, staticRenderFns } from "./DepartmentCard.vue?vue&type=template&id=bddcf216&scoped=true"
import script from "./DepartmentCard.vue?vue&type=script&lang=ts"
export * from "./DepartmentCard.vue?vue&type=script&lang=ts"
import style0 from "./DepartmentCard.vue?vue&type=style&index=0&id=bddcf216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddcf216",
  null
  
)

export default component.exports